module.exports = __webpack_public_path__ + "img/guanyu_yous2@2x.df9d560c.png";